import { render, staticRenderFns } from "./draftsTable.vue?vue&type=template&id=1404d596&"
import script from "./draftsTable.vue?vue&type=script&lang=js&"
export * from "./draftsTable.vue?vue&type=script&lang=js&"
import style0 from "./draftsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports